import { useContext, useState } from "react";
import { Drawer } from "antd";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import { DrawerContext } from "../../../../store/DrawerContext/DrawerContext";
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { BlockConversion } from "../../../pages/menuReports/blocks/BlockConversion";
import SelectMonthPeriod from "../selectMonths/SelectMonthPeriod";
import { PageFilters, PageFilterField } from "../../../pages/common/PageFilters";
import { DrawerPanelTitle, drawerPanelStyles } from "../../../pages/common/Drawers/DrawerPanelTitle";

export const LocationViewAndConversionStatsDrawer = () => {

    const { projectGroup } = useAuth();
        
    const { locationViewAdnConversionStatsDrawer, setLocationViewAdnConversionStatsDrawer} = useContext(DrawerContext)
    const [selectedType, setSelectedType] = useState(locationViewAdnConversionStatsDrawer.selectedType);    
    const [conversionData, setConversionData] = useState<any>();    

    useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${locationViewAdnConversionStatsDrawer.location.groupAccount}/summary/info/${locationViewAdnConversionStatsDrawer.location.name}?periodOpt=${selectedType}`, {}, [],
    (data: any) => {
        setConversionData(data);                    
    });

    return (
        <Drawer
            title={
              <DrawerPanelTitle
                title="Métricas de Rendimiento"
                location={locationViewAdnConversionStatsDrawer.location}
              />
            }
            placement="right"
            width={'75%'}
            open={true}
            onClose={() => setLocationViewAdnConversionStatsDrawer(null)}
            {...drawerPanelStyles}
        >
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8, marginRight: 20 }}>
              <PageFilters>
                <PageFilterField label='Periodo'>
                  <SelectMonthPeriod setSelectedType={setSelectedType} defaultValue={selectedType}/>
                </PageFilterField>
              </PageFilters>
            </div>
            <BlockConversion data={conversionData} selectedType={selectedType}/>
        </Drawer>
    )
}
